(() => {
  const container = document.getElementById('recipe-content');
  if (!container) return;

  const productTemplate = document.querySelector('template[data-product-recipe]');

  const update = (id) => {
    if (!id) return;

    const tpl = document.querySelector(`template[data-variant-recipe="${id}"]`);
    container.innerHTML = (tpl || productTemplate)?.innerHTML || '';
  };

  document.addEventListener('variant:change', e => {
    update(e.detail?.variant?.id);
  });

  document.addEventListener('change', e => {
    const input = e.target.closest('form')?.querySelector('[name="id"]');
    update(input?.value);
  });
})();